export enum EBType {
    BALANCE = 0,
    NET = 1,
    SPECIAL = 2,
    BONUS = 3,
    UnifiedAccount = 6
}

export enum EBTypeName {
    BALANCE = 'balance',
    NET = 'net',
    BONUS = 'bonus'
}

export interface IItem {
    active: boolean,
    brand: string,
    name: string,
    nm: number,
    categoryName: string,
    hasBiggestBet?: boolean,
    bet?: number,
    minBet?: number
}
